import React from 'react'
import styled from 'styled-components'
import EmptyImg from './empty.png'

const Box = styled.div`
  width: 100%;
  padding: 20px;
  img {
    display: block;
    margin: 0 auto;
  }
  p {
    width: 100%;
    text-align: center;
    margin-top: -10px;
  }
`

export const EmptyContent = () => {
  return (
    <Box>
      <img src={EmptyImg} alt='no result' />
      <p>抱歉，没有找到相关内容</p>
    </Box>
  )
}
